import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import React, { useContext } from 'react';
import { StaticContext } from '@sm/webassets/StaticContext';
import { generateMetricsAttribute } from '@sm/metrics';
import { Button } from '@wds/button';
import ColoredLogoWithText from '~app/components/surveyThanksLogo/ColoredLogoWithText';
import { getSrc } from '~app/helpers/assetLoading';
import { productResearchImg } from '~static/images/userResearch';
import useStyles from './useStyles';
import { CTA_LINKS, USER_RESEARCH_STANDARD_CTA } from '~app/components/constants';

type UserResearchProps = {
  utSource2: string;
};

const COPY = {
  userHeader: 'Help us improve your survey experience',
  userAlt: 'User Research',
  userSubHeader: 'Tell us how you feel about taking surveys so we can improve the experience for people like you.',
  userCTA: 'Share your opinion',
};

const UserResearchEndpage = ({ utSource2 }: UserResearchProps): React.ReactElement => {
  const { userHeader, userSubHeader, userCTA, userAlt } = COPY;

  const CTA_LINK = CTA_LINKS[utSource2] || USER_RESEARCH_STANDARD_CTA;

  const { pathImage, mainGrid, pageContent } = useStyles();
  const {
    smParams: { surveyId, collectorId, respondentId },
    templateType,
  } = useContext(StaticContext);

  const metricsData = generateMetricsAttribute({
    data: {
      amplitudeEvent: 'user endpage interaction',
      itemSelected: 'button',
      templateType,
      surveyId,
      collectorId,
      respondentId,
      log: {
        message: `survey-thanks-${utSource2}-PollingEndpage`,
      },
    },
  });

  return (
    <>
      <ColoredLogoWithText
        utSource={utSource2}
        utSource2={utSource2}
        isThanksText
        isResearchPage
        amplitudeEvent="endpage user interaction"
      />
      <Box display="flex" alignItems="center" justifyContent="center">
        <Box className={mainGrid}>
          <img src={getSrc(productResearchImg)} alt={userAlt} className={pathImage} />
          <Box pt={4} pb={4}>
            <Box className={pageContent}>
              <Typography variant="cardTitle" weight="medium" component="h1">
                {userHeader}
              </Typography>
              <Typography variant="bodySm" component="span">
                {userSubHeader}
              </Typography>
              <Button size="md" href={CTA_LINK} data-sm-metrics={metricsData} variant="primary">
                {userCTA}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default UserResearchEndpage;
